module.exports = __webpack_public_path__ + "img/sign-out.24b7bc50.png";